export const TOKEN_DEMO = 'demo';